export const THEMES = {
    primary: {
      name: 'Primary',
      emphasis: '#001329',
      standard: '#001D3D',
      subtle: '#2A435D',
      gradient: {
        color: '#001D3D',
        type: 'linear',
        stops: [
          { offset: '0%', opacity: '1' },
          { offset: '100%', opacity: '0' }
        ]
      }
    },
    secondary: {
      name: 'Secondary',
      emphasis: '#428AAE',
      standard: '#67BDE8',
      subtle: '#C9EDFF',
      gradient: {
        color: '#C9EDFF',
        type: 'linear',
        stops: [
          { offset: '0%', opacity: '1' },
          { offset: '100%', opacity: '0' }
        ]
      }
    },
    tertiary: {
      name: 'Tertiary',
      emphasis: '#1B9643',
      standard: '#2CB85A',
      subtle: '#CAFFDB',
      gradient: {
        color: '#CAFFDB',
        type: 'linear',
        stops: [
          { offset: '0%', opacity: '1' },
          { offset: '100%', opacity: '0' }
        ]
      }
    },
    light: {
      name: 'Light',
      emphasis: '#D0CBCA',
      standard: '#FAF4F2',
      subtle: '#FDFAF9',
      gradient: {
        color: '#FDFAF9',
        type: 'linear',
        stops: [
          { offset: '0%', opacity: '1' },
          { offset: '100%', opacity: '0' }
        ]
      }
    }
  };